import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { regolaPassword, validaPassword, lunghezzaMinima } from '../utils/regolaPassword';
import api from '../api';

export default function CambiaPassword() {
  const { utente, setUtente, logout } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ password_attuale: '', nuova_password: '', conferma: '' });
  const [errore, setErrore] = useState('');
  const [caricamento, setCaricamento] = useState(false);
  const obbligatorio = utente?.deve_cambiare_password;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrore('');
    if (form.nuova_password !== form.conferma) return setErrore('Le due password non coincidono');
    const erroreRegola = validaPassword(form.nuova_password, utente?.email, utente?.ruolo);
    if (erroreRegola) return setErrore(erroreRegola);

    setCaricamento(true);
    try {
      const res = await api.post('/auth/cambia-password', {
        password_attuale: form.password_attuale,
        nuova_password: form.nuova_password,
      });
      localStorage.setItem('token', res.data.token);
      setUtente(u => ({ ...u, deve_cambiare_password: false }));
      navigate('/');
    } catch (err) {
      setErrore(err.response?.data?.errore || 'Errore di connessione');
    } finally {
      setCaricamento(false);
    }
  };

  const aggiorna = (campo, valore) => setForm(prev => ({ ...prev, [campo]: valore }));

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.logoBox}>
          <img src="/logo_boldrin.svg" alt="Studio Boldrin" style={styles.logo} />
        </div>
        <div style={styles.divider}></div>
        <h2 style={styles.title}>{obbligatorio ? 'Scegli una nuova password' : 'Cambia password'}</h2>
        <p style={styles.subtitle}>
          {obbligatorio ? 'Stai usando una password temporanea: per continuare scegline una tua. ' : ''}
          {regolaPassword(utente?.ruolo)}
        </p>
        <form onSubmit={handleSubmit}>
          {errore && <div style={styles.errore}>{errore}</div>}
          <div style={styles.campo}>
            <label style={styles.label}>{obbligatorio ? 'Password temporanea' : 'Password attuale'}</label>
            <input type="password" autoComplete="current-password" value={form.password_attuale} onChange={e => aggiorna('password_attuale', e.target.value)} required style={styles.input} />
          </div>
          <div style={styles.campo}>
            <label style={styles.label}>Nuova password</label>
            <input type="password" autoComplete="new-password" value={form.nuova_password} onChange={e => aggiorna('nuova_password', e.target.value)} required minLength={lunghezzaMinima(utente?.ruolo)} style={styles.input} />
          </div>
          <div style={styles.campo}>
            <label style={styles.label}>Ripeti la nuova password</label>
            <input type="password" autoComplete="new-password" value={form.conferma} onChange={e => aggiorna('conferma', e.target.value)} required minLength={lunghezzaMinima(utente?.ruolo)} style={styles.input} />
          </div>
          <button type="submit" disabled={caricamento} style={styles.bottone}>
            {caricamento ? 'Salvataggio...' : 'Salva nuova password'}
          </button>
          <button type="button" onClick={obbligatorio ? logout : () => navigate(-1)} style={styles.secondario}>
            {obbligatorio ? 'Esci' : 'Annulla'}
          </button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  container: { display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: '#232323' },
  card: { background: 'white', padding: '2.5rem', borderRadius: '12px', boxShadow: '0 4px 24px rgba(0,0,0,0.3)', width: '100%', maxWidth: '420px', margin: '0 1rem' },
  logoBox: { textAlign: 'center', marginBottom: '1rem' },
  logo: { height: '40px' },
  divider: { height: '3px', background: '#D1D179', width: '40px', margin: '0 auto 1.2rem', borderRadius: '2px' },
  title: { margin: 0, fontSize: '1.1rem', color: '#232323', textAlign: 'center', fontWeight: 600 },
  subtitle: { color: '#888', textAlign: 'center', margin: '0.5rem 0 1.5rem', fontSize: '0.85rem' },
  campo: { marginBottom: '1rem' },
  label: { fontSize: '0.8rem', color: '#555', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.03em' },
  input: { width: '100%', padding: '0.7rem', border: '1px solid #ddd', borderRadius: '6px', fontSize: '0.95rem', boxSizing: 'border-box', marginTop: '0.3rem' },
  bottone: { width: '100%', padding: '0.8rem', background: '#232323', color: 'white', border: 'none', borderRadius: '6px', fontSize: '0.95rem', cursor: 'pointer', marginTop: '0.5rem', fontWeight: 600 },
  secondario: { width: '100%', padding: '0.6rem', background: 'white', color: '#555', border: 'none', fontSize: '0.85rem', cursor: 'pointer', marginTop: '0.5rem' },
  errore: { background: '#fef2f2', color: '#b91c1c', padding: '0.7rem', borderRadius: '6px', marginBottom: '1rem', textAlign: 'center', fontSize: '0.85rem', border: '1px solid #fecaca' },
};
